import React from 'react'

import styles from './MainBanner.module.scss'
import BubbleIcon from '../../assets/images/mainBanner/bubble_icon.gif'
import Bubble from '../common/bubble/Bubble'
import TitleText from '../common/titleText/TitleText'

const MainBanner = () => {
  const backgroundTitle: string = 'How we work'
  const title: string = 'Marketing'
  const text: string = 'One place for all your work-boosting, efficiency-enhancing, totally amazing ways we work.'
  const bubbleText: string = 'Those adjectives!'

  return (
    <div
      style={{ background: 'linear-gradient(0deg, #400103 0%, #CE0202 91.2%)' }}
      className="flex flex-col h-full items-center overflow-y-auto overflow-x-hidden"
    >
      <div className={styles.mainTitleContainer}>
        <h1>{backgroundTitle}</h1>
      </div>
      <TitleText
        containerClassName={styles.titleTextContainer}
        titleClassName={`${styles.title} text-[#FFF]`}
        textClassName={`${styles.text} text-[#FFF]`}
        titleType="7xl-display"
        titleTag="h1"
        textType="xl-heading"
        textTag="p"
        title={title}
        text={text}
      >
        <Bubble text={bubbleText} icon={BubbleIcon} className={styles.bubble} direction="up" />
      </TitleText>
      <div style={{ backgroundColor: '#400103' }} className=" flex-1 w-[150%] px-[25%] mt-64">
        <svg
          width="100%"
          height="400"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          className="-mt-[400px]"
          stroke="white"
        >
          <path d="M0,100 Q50,0 100,100 Z" fill="#FFFFFF" />
        </svg>
      </div>
    </div>
  )
}

export default MainBanner
